var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMultiChoice = function SvgMultiChoice(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 134,
    viewBox: "0 0 154 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2737_94008)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2737_94008",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7 9.23858 9.23858 7 12 7H142C144.761 7 147 9.23858 147 12V122C147 124.761 144.761 127 142 127H12C9.23857 127 7 124.761 7 122V12Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7 9.23858 9.23858 7 12 7H142C144.761 7 147 9.23858 147 12V122C147 124.761 144.761 127 142 127H12C9.23857 127 7 124.761 7 122V12Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 27,
    width: 124,
    height: 14,
    rx: 1.57895,
    fill: "#F1F3F5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 34,
    x2: 132,
    y2: 34,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 56.3333L23 58.3333L29.6667 51.6667",
    stroke: "#343A40",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 57V61.6667C29 62.0203 28.8595 62.3594 28.6095 62.6095C28.3594 62.8595 28.0203 63 27.6667 63H18.3333C17.9797 63 17.6406 62.8595 17.3905 62.6095C17.1405 62.3594 17 62.0203 17 61.6667V52.3333C17 51.9797 17.1405 51.6406 17.3905 51.3905C17.6406 51.1405 17.9797 51 18.3333 51H25.6667",
    stroke: "#4C6EF5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 50,
    width: 105,
    height: 14,
    rx: 1.57895,
    fill: "#F1F3F5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41,
    y1: 57,
    x2: 132,
    y2: 57,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 81V85.6667C29 86.0203 28.8595 86.3594 28.6095 86.6095C28.3594 86.8595 28.0203 87 27.6667 87H18.3333C17.9797 87 17.6406 86.8595 17.3905 86.6095C17.1405 86.3594 17 86.0203 17 85.6667V76.3333C17 75.9797 17.1405 75.6406 17.3905 75.3905C17.6406 75.1405 17.9797 75 18.3333 75H25.6667",
    stroke: "#4C6EF5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 74,
    width: 105,
    height: 14,
    rx: 1.57895,
    fill: "#F1F3F5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41,
    y1: 81,
    x2: 132,
    y2: 81,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 104.333L23 106.333L29.6667 99.6667",
    stroke: "#343A40",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 105V109.667C29 110.02 28.8595 110.359 28.6095 110.609C28.3594 110.86 28.0203 111 27.6667 111H18.3333C17.9797 111 17.6406 110.86 17.3905 110.609C17.1405 110.359 17 110.02 17 109.667V100.333C17 99.9797 17.1405 99.6406 17.3905 99.3905C17.6406 99.1405 17.9797 99 18.3333 99H25.6667",
    stroke: "#4C6EF5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 98,
    width: 105,
    height: 14,
    rx: 1.57895,
    fill: "#F1F3F5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41,
    y1: 105,
    x2: 132,
    y2: 105,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7 2.61116 14.6112 -5 24 -5H130C139.389 -5 147 2.61116 147 12V19C147 19 144.761 19 142 19H12C9.23858 19 7 19 7 19V12ZM147 127H7H147ZM7 127V7V127ZM147 7V127V7Z",
    fill: "#343A40",
    mask: "url(#path-1-inside-1_2737_94008)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2737_94008",
    x: 0,
    y: 0,
    width: 154,
    height: 134,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368627 0 0 0 0 0.364706 0 0 0 0 0.494118 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2737_94008"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2737_94008",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMultiChoice);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";